import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Field from 'li-components/lib/Field/Field'
import SvgIcon from 'li-components/lib/SvgIcon'
import vars from 'li-components/lib/styles'

const AttachmentField = styled(Field)`
  > main {
    height: 100%;
    min-height: 3.25rem;
  }
`

const Inner = styled.div`
  display: flex;
  align-items: center;
  min-height: 3.25rem;
  cursor: pointer;

  .SvgIcon {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: 0.5rem;

    svg {
      width: 1.25em;
      height: 1.25em;
      fill: ${vars.brandPrimary};
    }
  }
`

const Attachment = styled.div`
  display: flex;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  border: 1px solid ${vars.cardBorderColor};
  border-radius: ${vars.inputBorderRadius};

  &:hover {
    svg {
      fill: ${vars.brandDanger};
    }
  }

  p {
    margin: 0;
  }

  .SvgIcon {
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:first-child {
      margin-right: 0.5rem;

      svg {
        width: 1.25em;
        height: 1.25em;
        fill: ${p => (p.hasError ? vars.brandDanger : vars.brandSecondary)};
      }
    }

    &:last-child {
      margin-left: auto;
      cursor: pointer;

      svg {
        width: 0.8em;
        height: 0.8em;
        fill: ${vars.grayLight};
      }

      &:hover {
        svg {
          fill: ${vars.brandDanger};
        }
      }
    }
  }
`

export default class Attachments extends Component {
  static propTypes = {
    fieldProps: PropTypes.object,
    files: PropTypes.array.isRequired,
    onRemoveFile: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    onClickAddFile: PropTypes.func,
  }

  static defaultProps = {
    fieldProps: {},
  }

  render() {
    const {
      fieldProps,
      files,
      onRemoveFile,
      loading,
      onClickAddFile,
    } = this.props

    return (
      <AttachmentField
        name="uploads"
        label="Attachments"
        allowOverflow
        {...fieldProps}
      >
        {files.map(file => (
          <Attachment key={file.uploadedAt} hasError={file.error}>
            <SvgIcon name={file.error ? 'exclamation-point-2' : 'document-1'} />
            <p>{file.error ? `${file.name || 'UPLOAD'} FAILED` : file.name}</p>
            <SvgIcon name="x-1" onClick={() => onRemoveFile(file)} />
          </Attachment>
        ))}
        <Inner onClick={onClickAddFile}>
          <SvgIcon name="paperclip-1" />
          {loading ? 'Loading...' : 'Add file or drop here'}
        </Inner>
      </AttachmentField>
    )
  }
}



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/help/components/Attachments.js